"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var stripe_js_1 = require("@stripe/stripe-js");
var Button_1 = __importDefault(require("./Button"));
var FormField_1 = require("./FormField");
var grid_1 = require("./grid");
var Modal_1 = __importDefault(require("./Modal"));
var Notice_1 = __importStar(require("./Notice"));
var spacing_1 = require("./spacing");
var typography_1 = require("./typography");
var utils_1 = require("./form/utils");
var layout_1 = require("../util/layout");
var icons_1 = require("../icons");
var colors_1 = require("../util/colors");
var StripeInputWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), utils_1.inputStyle);
var FieldWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: 360px;\n"], ["\n  max-width: 360px;\n"])));
var PadRightMd = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  @media (min-width: ", "px) {\n    padding-right: ", ";\n  }\n"], ["\n  @media (min-width: ", "px) {\n    padding-right: ", ";\n  }\n"])), (0, layout_1.breakPoint)('md'), (0, layout_1.space)(2));
var StripeCardForm = function (_a) {
    var onSuccess = _a.onSuccess, onCancel = _a.onCancel, loading = _a.loading, modalProps = _a.modalProps, parentError = _a.error, modal = _a.modal, renderFooter = _a.renderFooter, _b = _a.requiredTreatment, requiredTreatment = _b === void 0 ? true : _b;
    var theme = (0, react_1.useContext)(styled_components_1.ThemeContext);
    var stripeElementOptions = {
        style: {
            base: {
                fontSize: "".concat(theme.typography.baseSize * 16, "px"),
                color: theme.colors.text,
            },
            invalid: {
                color: theme.colors.error,
            },
        },
    };
    var _c = (0, react_1.useReducer)(function (prevEdits, _a) {
        var _b;
        var field = _a.field, value = _a.value;
        return (__assign(__assign({}, prevEdits), (_b = {}, _b[field] = value, _b)));
    }, {}), cardEdits = _c[0], updateField = _c[1];
    var _d = (0, react_1.useState)(false), submitting = _d[0], setSubmitting = _d[1];
    var _e = (0, react_1.useState)(false), showMissingFields = _e[0], setShowMissingFields = _e[1];
    var _f = (0, react_1.useState)(null), error = _f[0], setError = _f[1];
    var _g = (0, react_1.useReducer)(function (errors, _a) {
        var _b;
        var field = _a.field, message = _a.message;
        return (__assign(__assign({}, errors), (_b = {}, _b[field] = message, _b)));
    }, {}), errors = _g[0], setErrors = _g[1];
    var stripe = (0, react_stripe_js_1.useStripe)();
    var elements = (0, react_stripe_js_1.useElements)();
    var allFieldsFilled = cardEdits.name &&
        cardEdits.zipcode &&
        cardEdits.card &&
        cardEdits.expiry &&
        cardEdits.cvv;
    var canSubmit = stripe && !loading && elements && !submitting;
    var onStripeChange = function (field, e) {
        if (e.error) {
            setErrors({ field: field, message: e.error.message });
        }
        else {
            setErrors({ field: field, message: null });
        }
        updateField({ field: field, value: e.complete });
    };
    var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, error, source;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!allFieldsFilled) {
                        setShowMissingFields(true);
                        return [2 /*return*/, { error: new Error('Please fill out the required fields') }];
                    }
                    if (!canSubmit) {
                        return [2 /*return*/, { error: new Error('Stripe not loaded') }];
                    }
                    setSubmitting(true);
                    return [4 /*yield*/, stripe.createSource(elements.getElement(react_stripe_js_1.CardNumberElement), {
                            type: 'card',
                            currency: 'usd',
                            owner: {
                                name: cardEdits.name,
                                address: {
                                    postal_code: cardEdits.zipcode,
                                },
                            },
                        })];
                case 1:
                    _a = _b.sent(), error = _a.error, source = _a.source;
                    if (error) {
                        setError(error.message);
                        return [2 /*return*/, { error: new Error(error.message) }];
                    }
                    setShowMissingFields(false);
                    setSubmitting(false);
                    onSuccess && onSuccess(source);
                    return [2 /*return*/, { source: source }];
            }
        });
    }); };
    var contents = (react_1.default.createElement(grid_1.Container, null,
        react_1.default.createElement(grid_1.Item, { cols: 12, pb: 3 },
            react_1.default.createElement(FieldWrapper, null,
                react_1.default.createElement(FormField_1.FormField, { label: "Name on payment card", field: "name", autoComplete: "name", onChange: updateField, required: requiredTreatment, error: showMissingFields && !cardEdits.name && 'This field is required' }))),
        react_1.default.createElement(grid_1.Item, { cols: 12, pb: 3 },
            react_1.default.createElement(FieldWrapper, null,
                react_1.default.createElement(FormField_1.FormField, { label: "Card number", field: "card", inputType: "none", error: errors['card'] ||
                        (showMissingFields && !cardEdits.card && 'This field is required'), required: requiredTreatment },
                    react_1.default.createElement(StripeInputWrapper, null,
                        react_1.default.createElement(react_stripe_js_1.CardNumberElement, { options: __assign(__assign({}, stripeElementOptions), { placeholder: '0000 0000 0000 0000' }), onChange: function (e) { return onStripeChange('card', e); } }))))),
        react_1.default.createElement(grid_1.Item, { cols: 6, mdCols: 12, pb: 3 },
            react_1.default.createElement(PadRightMd, null,
                react_1.default.createElement(FieldWrapper, null,
                    react_1.default.createElement(FormField_1.FormField, { label: "Exp. date", field: "expiry", inputType: "none", required: requiredTreatment, error: errors['expiry'] ||
                            (showMissingFields &&
                                !cardEdits.expiry &&
                                'This field is required') },
                        react_1.default.createElement(StripeInputWrapper, null,
                            react_1.default.createElement(react_stripe_js_1.CardExpiryElement, { options: stripeElementOptions, onChange: function (e) { return onStripeChange('expiry', e); } })))))),
        react_1.default.createElement(grid_1.Item, { cols: 6, mdCols: 12, pb: 3 },
            react_1.default.createElement(FieldWrapper, null,
                react_1.default.createElement(FormField_1.FormField, { label: "CVV", field: "cvv", inputType: "none", placeholder: "123", required: requiredTreatment, error: errors['cvv'] ||
                        (showMissingFields && !cardEdits.cvv && 'This field is required') },
                    react_1.default.createElement(StripeInputWrapper, null,
                        react_1.default.createElement(react_stripe_js_1.CardCvcElement, { options: __assign(__assign({}, stripeElementOptions), { placeholder: '123' }), onChange: function (e) { return onStripeChange('cvv', e); } }))))),
        react_1.default.createElement(grid_1.Item, { cols: 12, pb: 3 },
            react_1.default.createElement(PadRightMd, null,
                react_1.default.createElement(FieldWrapper, null,
                    react_1.default.createElement(FormField_1.FormField, { label: "ZIP code", field: "zipcode", autoComplete: "postal-code", onChange: updateField, placeholder: "12345", inputMode: "numeric", required: requiredTreatment, error: errors['zipcode'] ||
                            (showMissingFields &&
                                !cardEdits.zipcode &&
                                'This field is required') })))),
        react_1.default.createElement(grid_1.Item, { cols: 12, direction: "row", align: "center" },
            react_1.default.createElement(icons_1.Lock, { color: colors_1.colors.gray600 }),
            react_1.default.createElement(typography_1.P, { color: colors_1.colors.gray600, pl: 1, style: { wordSpacing: '1px' } }, "Your information is secure and won't be sold")),
        error || parentError ? (react_1.default.createElement(grid_1.Item, { cols: 12 },
            react_1.default.createElement(typography_1.P, { pt: 2, error: true }, error || parentError))) : null));
    var footer = renderFooter ? (renderFooter({ submitDisabled: !canSubmit, submit: submit })) : (react_1.default.createElement(react_1.default.Fragment, null,
        !allFieldsFilled && showMissingFields && (react_1.default.createElement(spacing_1.Div, { py: 2 },
            react_1.default.createElement(Notice_1.default, { severity: Notice_1.severities.WARN }, "Please fill out the required fields above."))),
        react_1.default.createElement(grid_1.Container, { justify: "flex-end" },
            react_1.default.createElement(spacing_1.Div, { pr: 2 },
                react_1.default.createElement(Button_1.default, { secondary: true, onClick: onCancel }, "Cancel")),
            react_1.default.createElement(Button_1.default, { disabled: !canSubmit, onClick: submit }, "Save card"))));
    if (modal)
        return (react_1.default.createElement(Modal_1.default, __assign({ open: true, titleText: "Add new card", onDismiss: onCancel }, modalProps, { renderFooter: function () { return footer; } }),
            react_1.default.createElement(grid_1.Container, { px: 1, pb: 4 }, contents)));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        contents,
        footer));
};
var StripeCardFormWithContext = function (_a) {
    var publishableKey = _a.publishableKey, rest = __rest(_a, ["publishableKey"]);
    var _b = (0, react_1.useState)(null), stripePromise = _b[0], setStripePromise = _b[1];
    (0, react_1.useEffect)(function () { return setStripePromise((0, stripe_js_1.loadStripe)(publishableKey)); }, [publishableKey]);
    return (react_1.default.createElement(react_stripe_js_1.Elements, { stripe: stripePromise },
        react_1.default.createElement(StripeCardForm, __assign({}, rest))));
};
exports.default = StripeCardFormWithContext;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=StripeCardForm.js.map